import { render, staticRenderFns } from "./ProblemaActual.vue?vue&type=template&id=55221721"
import script from "./ProblemaActual.vue?vue&type=script&lang=js"
export * from "./ProblemaActual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports